import React, { useState, useReducer, useContext } from 'react';
import PropTypes from 'prop-types';
import { ChatContext } from 'context/Context';

import users from 'data/chat/people';
import rawThreads from 'data/chat/threads';
import rawMessages from 'data/chat/messages';
import groups from 'data/chat/groups';

import { arrayReducer } from 'reducers/arrayReducer';

import AppContext from 'context/Context';
import { postToTask } from 'y4/Y4Api';
import y from 'y4/Utils';

const ChatProvider = ({ children }) => {
  const [messages, messagesDispatch] = useReducer(arrayReducer, rawMessages);
  const [threads, threadsDispatch] = useReducer(arrayReducer, rawThreads);
  const [currentThread, setCurrentThread] = useState(threads[0]);
  const [textAreaInitialHeight, setTextAreaInitialHeight] = useState(32);
  const [activeThreadId, setActiveThreadId] = useState(threads[0].id);
  const [isOpenThreadInfo, setIsOpenThreadInfo] = useState(false);
  const [scrollToBottom, setScrollToBottom] = useState(true);

  const {
    config: { corp }
  } = useContext(AppContext);

  const getUser = thread => {
    let user = {};
    if (thread.type === 'group') {
      const { name, members } = groups.find(({ id }) => id === thread.groupId);
      user = {
        name,
        avatarSrc: members.map(
          member => users.find(({ id }) => id === member.userId).avatarSrc
        )
      };
    } else {
      user = users.find(({ id }) => id === thread.userId);
    }
    return user;
  };

  const formatDate = date => {
    const options = {
      weekday: 'short',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    };

    const now = date
      .toLocaleString('en-US', options)
      .split(',')
      .map(item => item.trim());

    return {
      day: now[0],
      hour: now[3],
      date: now[1] + ', ' + now[2]
    };
  };

  const fixHtml = html => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html; // 解析 HTML 为 DOM 结构

    // 查找所有 h1 标签并替换
    const h1Tags = tempDiv.querySelectorAll('h1');
    h1Tags.forEach(h1 => {
      const h4 = document.createElement('h4');
      h4.innerHTML = h1.innerHTML; // 保留内容和嵌套结构
      h1.parentNode.replaceChild(h4, h1); // 替换标签
    });

    // 查找所有 h1 标签并替换
    const h2Tags = tempDiv.querySelectorAll('h2');
    h2Tags.forEach(h2 => {
      const h5 = document.createElement('h5');
      h5.innerHTML = h2.innerHTML; // 保留内容和嵌套结构
      h2.parentNode.replaceChild(h5, h2); // 替换标签
    });

    return tempDiv.innerHTML; // 转回字符串
  };

  const autoReply = ({ newMessage }) => {
    postToTask('TASK_Chat_Auto_Reply', {
      corp,
      message: newMessage.message
    }).then(rt => {
      if (rt.isOk()) {
        const replyMessage = {
          senderUserId: currentThread.userId,
          message: fixHtml(rt.data.message),
          status: 'delivered',
          time: formatDate(new Date())
        };

        const { content } = messages.find(
          ({ id }) => id === currentThread.messagesId
        );
        messagesDispatch({
          type: 'EDIT',
          payload: {
            id: currentThread.messagesId,
            content: [...content, newMessage, replyMessage]
          },
          id: currentThread.messagesId
        });

        threadsDispatch({
          type: 'EDIT',
          payload: currentThread,
          id: currentThread.id,
          isUpdatedStart: true
        });

        setScrollToBottom(true);
      } else {
        y.toastError(rt.message);
      }
    });

    /**
    if (newMessage.message.toLowerCase().includes('hello')) {
      setTimeout(() => {
        const replyMessage = {
          senderUserId: currentThread.userId,
          message: 'Hi there! How can I help you?',
          status: 'delivered',
          time: formatDate(new Date())
        };

        const { content } = messages.find(
          ({ id }) => id === currentThread.messagesId
        );

        console.log('Auto-reply triggered', content);

        messagesDispatch({
          type: 'EDIT',
          payload: {
            id: currentThread.messagesId,
            content: [...content, newMessage, replyMessage]
          },
          id: currentThread.messagesId
        });

        threadsDispatch({
          type: 'EDIT',
          payload: currentThread,
          id: currentThread.id,
          isUpdatedStart: true
        });

        setScrollToBottom(true);
      }, 5000);
    }
    **/
  };

  const value = {
    users,
    groups,
    threads,
    getUser,
    messages,
    activeThreadId,
    setActiveThreadId,
    threadsDispatch,
    messagesDispatch,
    textAreaInitialHeight,
    setTextAreaInitialHeight,
    isOpenThreadInfo,
    setIsOpenThreadInfo,
    currentThread,
    setCurrentThread,
    scrollToBottom,
    setScrollToBottom,
    autoReply,
    formatDate
  };

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

ChatProvider.propTypes = { children: PropTypes.node.isRequired };

export default ChatProvider;
